import { Box, Heading, Text } from "@chakra-ui/layout"
import { Button, Flex } from "@chakra-ui/react"
import { useLocation } from "@reach/router"
import { Image } from "../image"
import { navigate } from "gatsby-link"
import { colors } from "../colors"
import { resendEmailVerification } from "../../utils/loginInfo"
import { toast } from "react-toastify"
import { usePurchasingCTAs } from "../form/usePurchasingCTAs"

export function ConfirmationModal({
  title,
  description,
  cta,
  ctaLabel,
  ctaColor,
  image,
  mobileImage,
}) {
  const { pathname } = useLocation()
  const { emailVerification } = usePurchasingCTAs()
  return (
    <Box p={{ base: `120px 0 60px`, md: "160px 0 80px" }}>
      <Box
        border={{ base: `none`, md: "1px solid rgba(174, 174, 178,.95)" }}
        maxW="800px"
        m="0px auto"
      >
        <Flex flexWrap={{ base: `wrap`, md: `nowrap` }}>
          <Box
            display={{ base: `none`, lg: `block` }}
            flex={{ base: "0 0 100%", md: "0 0 50%" }}
            p={{ base: `0 20px`, md: 0 }}
          >
            {image?.localFile?.childImageSharp && (
              <Image image={image.localFile.childImageSharp} />
            )}
          </Box>
          <Box
            flex={{ base: "0 0 100%", md: "0 0 50%" }}
            alignSelf="center"
            p={{ base: `0 20px`, md: `0 50px` }}
          >
            <Heading
              fontWeight="600"
              fontSize={"32px"}
              lineHeight="27px"
              mb={{ base: `30px`, md: "54px" }}
              color="black"
              textAlign="center"
              textTransform="uppercase"
            >
              {title}
            </Heading>
            <Text
              maxW={{ base: `338px`, lg: `100%` }}
              ml="auto"
              mr="auto"
              fontSize={"16px"}
              lineHeight="21px"
              mb={{ base: `30px`, md: "60px" }}
              color="black"
              textAlign="center"
            >
              {description}
            </Text>
            {mobileImage && (
              <Box display={{ base: `block`, lg: `none` }} mb="30px">
                {mobileImage?.localFile?.childImageSharp && (
                  <Image image={mobileImage.localFile.childImageSharp} />
                )}
              </Box>
            )}

            {cta && (
              <Button
                borderRadius="25px"
                type="button"
                variant="solid"
                bgColor={ctaColor}
                color={"white"}
                width="full"
                fontFamily="Teko"
                fontSize="20px"
                lineHeight="16px"
                fontWeight="500"
                height="50px"
                textTransform="uppercase"
                onClick={() => navigate(cta)}
                _hover={{ bg: "#CEFF1A", color: colors.purple }}
              >
                {ctaLabel}
              </Button>
            )}

            {pathname === emailVerification?.link && (
              <Button
                mt="20px"
                borderRadius="25px"
                type="button"
                variant="solid"
                bgColor={ctaColor}
                color={"white"}
                width="full"
                fontFamily="Teko"
                fontSize="20px"
                lineHeight="16px"
                fontWeight="500"
                height="50px"
                textTransform="uppercase"
                onClick={() => resendEmailVerification(toast)}
                _hover={{ bg: "#CEFF1A", color: colors.purple }}
              >
                RESEND VERIFICATION EMAIL
              </Button>
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}
